/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';
import {
  COLOR_CHIP,
  INTERACTIVE_PLP_SLP_COLOR_SWATCH_DIMENSIONS,
} from '@tcp/core/src/components/features/browse/PlpTile/plpTileConstants';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const styleFunc = (ab, style1, style2) => {
  if (ab) {
    return style1;
  }
  return style2;
};

export const ColorChipButton = Styled.button`
  display: inline;
  overflow: hidden;
  padding: 0;
  border: 0;
  border-radius: 50%;
  font-size: 0;
  cursor: pointer;
  ${(props) =>
    props.imageUrl
      ? `background: url(${props.imageUrl}) no-repeat center`
      : 'background: transparent'};
  background-size: contain;
  ${(props) =>
    props.isActive &&
    !props.isTileRedesignAB &&
    css`
      border: 1px solid !important;
      padding: 1px 1px 0px 1px;
      box-shadow: inset 0 0 0 1px #ffffff;
    `};

  ${(props) => props.isDynamicColorSwatchesEnabled && `flex-shrink:0;`}

${(props) =>
  props.isTileRedesignAB &&
  css`
    border: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY} !important;
  `}

  ${(props) =>
    [COLOR_CHIP.PRODUCTS_WHITE, COLOR_CHIP.PRODUCTS_SIMPLYWHT].includes(props.name) &&
    css`
      border: 1px solid #9b9b9b;
    `}
    @media ${(props) => props.theme.mediaQuery.small} {
      width: ${(props) => (props.isAltPlp ? '24px' : '15px')};
      height: ${(props) => (props.isAltPlp ? '24px' : '15px')};
      margin-right: ${(props) => (props.isAltPlp ? '12px' : '7px')};
      ${(props) =>
        props.isActive &&
        !props.isDynamicColorSwatchesEnabled &&
        css`
          width: ${(prop) => (prop.isAltPlp ? '25px' : '16px')};
          height: ${(prop) => (prop.isAltPlp ? '25px' : '16px')};
        `}
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: ${(props) => (props.isAltPlp ? '24px' : '18px')};
      height: ${(props) => (props.isAltPlp ? '24px' : '18px')};
      margin-right: ${(props) =>
        styleFunc(
          props.isTileRedesignAB,
          props.theme.spacing.ELEM_SPACING.XS,
          props.theme.spacing.ELEM_SPACING.SM
        )};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: ${(props) => (props.isHlp ? '16px' : props.isAltPlp ? '24px' : '20px')};
      height: ${(props) => (props.isHlp ? '16px' : props.isAltPlp ? '24px' : '20px')};
      margin-right: ${(props) =>
        props.isHlp
          ? '7px'
          : styleFunc(
              props.isTileRedesignAB,
              props.theme.spacing.ELEM_SPACING.XS,
              props.theme.spacing.ELEM_SPACING.SM
            )};
    }
`;

export const ColorChipText = Styled(ColorChipButton)`
    width: auto;
    height: auto;
    vertical-align: top;
    border-radius: unset;
    ${(props) => props.isDynamicColorSwatchesEnabled && `margin-right:0;`}
`;

ColorChipButton.displayName = 'ColorChipButton';
export const NextButton = Styled.button`
    margin-left: 5px;
    margin-top: ${(props) =>
      styleFunc(props.isTileRedesignAB && props.isHlp, props.theme.spacing.ELEM_SPACING.XXS, '')};
    border: none;
    background: url(${(props) => props.arrowRight});
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 4px;
    cursor: pointer;
    ${(props) =>
      !props.shouldScroll &&
      css`
        display: none;
      `}
`;
NextButton.displayName = 'NextButton';

export const AltPlpSwatchPlusNumber = Styled.span`
  width: 17px;
  height: 24px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #595959;
  flex: none;
  order: 4;
  flex-grow: 0;
`;

export const ColorTextWrapper = Styled.div`
${(props) => (props?.isEmpty ? 'height: 16px;' : '')}
.color-text {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 10px;
    }
  }
`;

const { containerGap, width, height, containerSidePadding } =
  INTERACTIVE_PLP_SLP_COLOR_SWATCH_DIMENSIONS;

export const InteractiveColorSwatchBandWrapper = Styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 2;

  .hidden-color-list-element {
    visibility: hidden;
    width: calc(100% - ${2 * containerSidePadding}px);
    height: 0;
  }
`;

export const ColorsCountWrapper = Styled.div`
  box-sizing: border-box;
  width: fit-content;
  padding: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 8px 0px 0px 0px;
  background: rgba(0,0,0,0.65);
`;

export const ColorsCountText = Styled(BodyCopy)`
  color: #fff;
  font-family: Nunito;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

export const ColorSwatchContainer = Styled.div`
  display: none;
  box-sizing: border-box;
  padding: 8px ${containerSidePadding}px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: rgba(0,0,0,0.65);

  .interactive-color-swatch-list {
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    width: 100%;
    gap: ${containerGap}px;
  }
`;

export const InteractiveColorChipButton = Styled.button`
  box-sizing: border-box;
  width: ${height}px;
  height: ${width}px;
  flex-shrink: 0;
  overflow: hidden;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  ${({ imageUrl }) =>
    imageUrl ? `background: url(${imageUrl}) no-repeat center` : 'background: transparent'};
  background-size: contain;
  border: 1px solid #D8D8D8;
`;

export const InteractiveColorChipText = Styled(InteractiveColorChipButton)`
  width: auto;
  height: auto;
  vertical-align: top;
  border-radius: unset;
  border: unset;

  .interactive-color-text {
    color: #fff;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
